import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Loader from "_shared/_views/loading/loader";
import _ from "lodash";
import { MouseEvent } from "react";
import Session from "users/__session/session";
import { Masked } from "work/_shared/masked-fields";
import DetailsTab from "work/proposals/_views/active/dialog-tabs/active-proposal-details-tab";
import Proposal from "work/proposals/proposal";
import ViewVendorTeam from "work/work-agreements/teams/vendor-team/_views/vendor-team-view";

const StyledLink = styled(Link, { shouldForwardProp: (prop) => prop !== "revised" })<{ revised: boolean }>(
  ({ theme, revised }) => ({
    alignItems: "center",
    color: theme.palette.text.primary,
    cursor: "pointer",
    display: "flex",
    overflow: "hidden",
    textDecoration: revised ? "underline dotted red" : "underline",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  })
);

type VendorTeamLinkProps = {
  proposal: Proposal;
  session: Session;
};

export default function VendorTeamLink(props: Readonly<VendorTeamLinkProps>) {
  const { proposal } = props;

  const { openDialog, closeDialog } = useDialog();

  async function handleClick(event: MouseEvent) {
    if (!proposal?.vendorTeam || Masked.isMasked(proposal.vendorTeam)) return;

    event.stopPropagation();

    openDialog({
      title: "Team Members",
      component: <Loader />,
    });

    if (!proposal || Masked.isMasked(proposal.vendorTeam)) return;

    closeDialog();

    openDialog({
      title: `${DetailsTab.name.toString()} Team`,
      MuiProps: { maxWidth: "md" },
      component: <ViewVendorTeam leader={proposal.vendorTeam?.leader} members={proposal.vendorTeam?.members} />,
    });
  }

  return (
    <StyledLink
      revised={
        !isNullOrUndefined(proposal?.supersedes) &&
        !_.isEqual(proposal?.vendorTeam, proposal?.supersedes?.workAgreement.vendorTeam)
      }
      onClick={handleClick}
    >
      View
    </StyledLink>
  );
}
